import { decryptFile } from 'utils/e2eEncryption';
import fetchMedia from 'utils/fetchMedia';

const fetchAndDecrypt = (attachment, aesKey) =>
  fetchMedia(attachment.httpLink)
    .then(res => res.text())
    .then(async text => {
      const decrypted = await decryptFile(text, aesKey);
      return new Blob([decrypted], {
        type: 'application/download',
      });
    });

export default fetchAndDecrypt;
